import React, { useEffect, useState } from "react";
import { backend, API_URL } from "../../../../config";
import {
  CssBaseline,
  Typography,
  Container,
  TextField,
  Grid,
  Button,
  Checkbox,
  FormControlLabel,
  CircularProgress,
  Modal,
  InputAdornment,
  IconButton,
  Divider,
  FormControl,
  FormGroup,
  FormHelperText,
} from "@mui/material";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";

import { useSelector } from "react-redux";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import InfoIcon from "@mui/icons-material/Info";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  iconButton: {
    padding: 10,
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const AddUser = (props) => {
  const classes = useStyles();

  const userId = props.match.params.id;

  const currentUserStore = useSelector((state) => state.current_user);

  const [user, setUser] = useState({
    username: "",
    email: "",
    first_name: "",
    last_name: "",
    old_password: "",
    new_password: "",
    new_password_confirm: "",
    restaurant_name: "",
    is_staff: false,
    is_active: true,
    email_order_confirmation: false,
    account_lock: false,
    needs_email_verified: true,
    needs_manual_review: true,
  });
  const [confirmModal, setConfirmModal] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);
  const [pwdVisibility, setPwdVisibility] = useState(false);
  const [pwdStrength, setPwdStrength] = useState(false);
  const [newStaffValue, setNewStaffValue] = useState(false);
  const [staffWarnModal, setStaffWarnModal] = useState(false);

  const togglePwdVisibility = () => setPwdVisibility(!pwdVisibility);

  const togglePwdStrength = () => setPwdStrength(!pwdStrength);

  const getPwdSimilarity = () => {
    const pwd = user.new_password.toLowerCase();

    let isSimilar = false;

    if (pwd.length > 3) {
      if (user.username.toLowerCase().includes(pwd)) isSimilar = true;

      if (user.email.toLowerCase().includes(pwd)) isSimilar = true;

      if (user.first_name.toLowerCase().includes(pwd)) isSimilar = true;

      if (user.last_name.toLowerCase().includes(pwd)) isSimilar = true;
    }

    return isSimilar;
  };

  const getPwdCommon = () => {
    const pwd = user.new_password;

    let isCommon = false;

    if (pwd.length > 3) {
      const commonPassword = [
        "123456",
        "password",
        "12345678",
        "1234",
        "pussy",
        "12345",
        "dragon",
        "qwerty",
        "696969",
        "mustang",
        "letmein",
        "baseball",
        "master",
        "michael",
        "football",
        "shadow",
        "monkey",
        "abc123",
        "pass",
        "6969",
        "jordan",
        "harley",
        "ranger",
        "iwantu",
        "jennifer",
        "hunter",
        "2000",
        "test",
        "batman",
        "trustno1",
        "thomas",
        "tigger",
        "robert",
        "access",
        "love",
        "buster",
        "1234567",
        "soccer",
        "hockey",
        "killer",
        "george",
        "sexy",
        "andrew",
        "charlie",
        "superman",
        "asshole",
        "dallas",
        "jessica",
        "panties",
        "pepper",
        "1111",
        "austin",
        "william",
        "daniel",
        "golfer",
        "summer",
        "heather",
        "hammer",
        "yankees",
        "joshua",
        "maggie",
        "biteme",
        "enter",
        "ashley",
        "thunder",
        "cowboy",
        "silver",
        "richard",
        "orange",
        "merlin",
        "michelle",
        "corvette",
        "bigdog",
        "cheese",
        "matthew",
        "121212",
        "patrick",
        "martin",
        "freedom",
        "ginger",
        "blowjob",
        "nicole",
        "sparky",
        "yellow",
        "camaro",
        "secret",
        "dick",
        "falcon",
        "taylor",
        "111111",
        "131313",
        "123123",
        "bitch",
        "hello",
        "scooter",
        "please",
        "porsche",
        "guitar",
        "chelsea",
        "black",
        "diamond",
        "nascar",
        "jackson",
        "cameron",
        "654321",
        "computer",
        "amanda",
        "wizard",
        "xxxxxxxx",
        "money",
        "phoenix",
        "mickey",
        "bailey",
        "knight",
        "iceman",
        "tigers",
        "purple",
        "andrea",
        "horny",
        "dakota",
        "aaaaaa",
        "player",
        "sunshine",
        "morgan",
        "starwars",
        "boomer",
        "cowboys",
        "edward",
        "charles",
        "girls",
        "booboo",
        "coffee",
        "xxxxxx",
        "bulldog",
        "ncc1701",
        "rabbit",
        "peanut",
        "john",
        "johnny",
        "gandalf",
        "spanky",
        "winter",
        "brandy",
        "compaq",
        "carlos",
        "tennis",
        "james",
        "mike",
        "brandon",
        "fender",
        "anthony",
        "blowme",
        "ferrari",
        "cookie",
        "chicken",
        "maverick",
        "chicago",
        "joseph",
        "diablo",
        "sexsex",
        "hardcore",
        "666666",
        "willie",
        "welcome",
        "chris",
        "panther",
        "yamaha",
        "justin",
        "banana",
        "driver",
        "marine",
        "angels",
        "fishing",
        "david",
        "maddog",
        "hooters",
        "wilson",
        "butthead",
        "dennis",
        "captain",
        "bigdick",
        "chester",
        "smokey",
        "xavier",
        "steven",
        "viking",
        "snoopy",
        "blue",
        "eagles",
        "winner",
        "samantha",
        "house",
        "miller",
        "flower",
        "jack",
        "firebird",
        "butter",
        "united",
        "turtle",
        "steelers",
        "tiffany",
        "zxcvbn",
        "tomcat",
        "golf",
        "bond007",
        "bear",
        "tiger",
        "doctor",
        "gateway",
        "gators",
        "angel",
        "junior",
        "thx1138",
        "porno",
        "badboy",
        "debbie",
        "spider",
        "melissa",
        "booger",
        "1212",
        "flyers",
        "fish",
        "porn",
        "matrix",
        "teens",
        "scooby",
        "jason",
        "walter",
        "cumshot",
        "boston",
        "braves",
        "yankee",
        "lover",
        "barney",
        "victor",
        "tucker",
        "princess",
        "mercedes",
        "5150",
        "doggie",
        "zzzzzz",
        "gunner",
        "horney",
        "bubba",
        "2112",
        "fred",
        "johnson",
        "xxxxx",
        "tits",
        "member",
        "boobs",
        "donald",
        "bigdaddy",
        "bronco",
        "penis",
        "voyager",
        "rangers",
        "birdie",
        "trouble",
        "white",
        "topgun",
        "bigtits",
        "bitches",
        "green",
        "super",
        "qazwsx",
        "magic",
        "lakers",
        "rachel",
        "slayer",
        "scott",
        "2222",
        "asdf",
        "video",
        "london",
        "7777",
        "marlboro",
        "srinivas",
        "internet",
        "action",
        "carter",
        "jasper",
        "monster",
        "teresa",
        "jeremy",
        "11111111",
        "bill",
        "crystal",
        "peter",
        "pussies",
        "cock",
        "beer",
        "rocket",
        "theman",
        "oliver",
        "prince",
        "beach",
        "amateur",
        "7777777",
        "muffin",
        "redsox",
        "star",
        "testing",
        "shannon",
        "murphy",
        "frank",
        "hannah",
        "dave",
        "eagle1",
        "11111",
        "mother",
        "nathan",
        "raiders",
        "steve",
        "forever",
        "angela",
        "viper",
        "ou812",
        "jake",
        "lovers",
        "suckit",
        "gregory",
        "buddy",
        "whatever",
        "young",
        "nicholas",
        "lucky",
        "helpme",
        "jackie",
        "monica",
        "midnight",
        "college",
        "baby",
        "brian",
        "mark",
        "startrek",
        "sierra",
        "leather",
        "232323",
        "4444",
        "beavis",
        "bigcock",
        "happy",
        "sophie",
        "ladies",
        "naughty",
        "giants",
        "booty",
        "blonde",
        "golden",
        "fire",
        "sandra",
        "pookie",
        "packers",
        "einstein",
        "dolphins",
        "chevy",
        "winston",
        "warrior",
        "sammy",
        "slut",
        "8675309",
        "zxcvbnm",
        "nipples",
        "power",
        "victoria",
        "asdfgh",
        "vagina",
        "toyota",
        "travis",
        "hotdog",
        "paris",
        "rock",
        "xxxx",
        "extreme",
        "redskins",
        "erotic",
        "dirty",
        "ford",
        "freddy",
        "arsenal",
        "access14",
        "wolf",
        "nipple",
        "iloveyou",
        "alex",
        "florida",
        "eric",
        "legend",
        "movie",
        "success",
        "rosebud",
        "jaguar",
        "great",
        "cool",
        "cooper",
        "1313",
        "scorpio",
        "mountain",
        "madison",
        "987654",
        "brazil",
        "lauren",
        "japan",
        "naked",
        "squirt",
        "stars",
        "apple",
        "alexis",
        "aaaa",
        "bonnie",
        "peaches",
        "jasmine",
        "kevin",
        "matt",
        "qwertyui",
        "danielle",
        "beaver",
        "4321",
        "4128",
        "runner",
        "swimming",
        "dolphin",
        "gordon",
        "casper",
        "stupid",
        "shit",
        "saturn",
        "gemini",
        "apples",
        "august",
        "3333",
        "canada",
        "blazer",
        "cumming",
        "hunting",
        "kitty",
        "rainbow",
        "112233",
        "arthur",
        "cream",
        "calvin",
        "shaved",
        "surfer",
        "samson",
        "kelly",
        "paul",
        "mine",
        "king",
        "racing",
        "5555",
        "eagle",
        "hentai",
        "newyork",
        "little",
        "redwings",
        "smith",
        "sticky",
        "cocacola",
        "animal",
        "broncos",
        "private",
        "skippy",
        "marvin",
        "blondes",
        "enjoy",
        "girl",
        "apollo",
        "parker",
        "qwert",
        "time",
        "sydney",
        "women",
        "voodoo",
        "magnum",
        "juice",
        "abgrtyu",
        "777777",
        "dreams",
        "maxwell",
        "music",
        "rush2112",
        "russia",
        "scorpion",
        "rebecca",
        "tester",
        "mistress",
        "phantom",
        "billy",
        "6666",
        "albert",
      ];

      isCommon = commonPassword.some((item) => pwd.includes(item));
    }

    return isCommon;
  };

  const handleChangeAdmin = (e) => {
    const { checked } = e.target;
    setNewStaffValue(checked);
    toggleStaffWarnModal();
  };

  const handleChange = (e) => {
    const { checked, name, value } = e.target;

    setUser((prevState) => {
      let userObj = { ...prevState };

      switch (name) {
        case "is_staff":
        case "is_active":
        case "email_order_confirmation":
        case "account_lock":
        case "needs_email_verified":
        case "needs_manual_review":
          userObj = { ...userObj, [name]: checked };
          break;
        default:
          userObj = { ...userObj, [name]: value };
      }

      return userObj;
    });
  };

  const resolveRequest = () => {
    setFinishedFlag(true);
    setLoadingFlag(false);
    toggleConfirmModal();

    if (!errorInfo.error) {
      props.history.push("/users");
    }
  };

  const resolveError = () => {
    setLoadingFlag(false);
    setErrorInfo({ error: false, message: "" });
    toggleConfirmModal();
  };

  const sendRequest = async () => {
    setLoadingFlag(true);

    let userPayload = {
      username: user.username,
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      is_staff: user.is_staff,
      is_active: user.is_active,
      email_order_confirmation: user.email_order_confirmation,
      account_lock: user.account_lock,
      needs_email_verified: user.needs_email_verified,
      needs_manual_review: user.needs_manual_review,
    };

    if (user.old_password !== "") {
      userPayload.old_password = user.old_password;
    }

    if (user.new_password !== "" && user.new_password_confirm !== "") {
      userPayload.new_password = user.new_password;
      userPayload.new_password_confirm = user.new_password_confirm;
    }

    if (userId) {
      await backend
        .patch(`${API_URL}users/${userId}`, userPayload)
        .then(({ data }) => {
          resolveRequest();
        })
        .catch((error) => {
          console.log(error);
          setErrorInfo({
            error: true,
            message: JSON.stringify(error.response.data),
          });
        });
    } else {
      userPayload.restaurant_name = user.restaurant_name;

      await backend
        .post(`${API_URL}users/`, userPayload)
        .then(({ data }) => {
          resolveRequest();
        })
        .catch((error) => {
          console.log(error);
          setErrorInfo({
            error: true,
            message: JSON.stringify(error.response.data),
          });
        });
    }
  };

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to
          {userId ? ` edit the user ` : ` create an user `}
          <b>{user.first_name || user.id}</b>?
          <div align="right">
            <Button
              onClick={() => toggleConfirmModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Saving customer information <br />
              This may take some time relative to the number of categories and
              fees configured
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while saving the customer information
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveError()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          Customer information have been successfully saved
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
              className={classes.button}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const toggleStaffWarnModal = () => setStaffWarnModal(!staffWarnModal);

  const staffWarnModalContent = (
    <div className={classes.modal}>
      <>
        {newStaffValue ? (
          <>
            You are giving admin access to the account {user.username}. This is
            a privileged role with full access to the software, including
            <span style={{ color: "red", fontWeight: "bold" }}>
              {` viewing, modifying, and deleting all users and orders.`}
            </span>
            <br />
            <br />
            Continue?
          </>
        ) : (
          <>
            You are removing admin access for the account {user.username}.
            <br />
            <br />
            Continue?
          </>
        )}
        <div align="right">
          <Button
            onClick={() => toggleStaffWarnModal()}
            className={classes.button}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleChange({
                target: { name: "is_staff", checked: newStaffValue },
              });
              toggleStaffWarnModal();
            }}
            className={classes.button}
          >
            Confirm
          </Button>
        </div>
      </>
    </div>
  );

  useEffect(() => {
    const getUser = async () => {
      await backend
        .get(`${API_URL}users/${userId}`)
        .then(({ data }) => {
          const dataMap = {
            ...data,
            restaurant_name: "",
            old_password: "",
            new_password: "",
            new_password_confirm: "",
          };

          setUser(dataMap);
        })
        .catch((error) => {
          console.log(error);
          const errorData = error.response.data;

          setErrorInfo({
            error: true,
            message:
              typeof errorData === "object"
                ? errorData.hasOwnProperty("message")
                  ? errorData.message
                  : errorData.detail
                : error.message,
          });
        });
    };

    if (!isNaN(userId)) {
      getUser();
    }
  }, [userId]);

  return (
    <>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Modal open={confirmModal} onClose={toggleConfirmModal}>
          {confirmModalContent}
        </Modal>
        <Modal open={staffWarnModal} onClose={toggleStaffWarnModal}>
          {staffWarnModalContent}
        </Modal>
        <div className={classes.paper}>
          <Typography color="primary" component="h4">
            Add User
          </Typography>
          <form
            className={classes.form}
            margin="dense"
            noValidate
            autoComplete="off"
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  InputProps={{
                    inputProps: {
                      autoComplete: "off",
                    },
                  }}
                  autoComplete="off"
                  size="small"
                  required={true}
                  variant="outlined"
                  label="Username: "
                  name="username"
                  value={user && user.username}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  InputProps={{
                    inputProps: {
                      autoComplete: "off",
                    },
                  }}
                  autoComplete="off"
                  size="small"
                  required={true}
                  variant="outlined"
                  label="Email Address: "
                  name="email"
                  value={user && user.email}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  required={true}
                  variant="outlined"
                  label="First Name: "
                  name="first_name"
                  value={user && user.first_name}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  required={true}
                  variant="outlined"
                  label="Last Name: "
                  name="last_name"
                  value={user && user.last_name}
                  onChange={handleChange}
                />
              </Grid>
              {!userId ? (
                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    size="small"
                    required={true}
                    variant="outlined"
                    label="User/Restaurant Name: "
                    name="restaurant_name"
                    value={user && user.restaurant_name}
                    onChange={handleChange}
                    helperText="This information will be used to create a Customer Location"
                  />
                </Grid>
              ) : (
                <></>
              )}
              {currentUserStore && currentUserStore.role_id > 12 ? (
                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    InputProps={{
                      inputProps: {
                        autoComplete: "new-password",
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle visibility"
                            onClick={() => togglePwdVisibility()}
                          >
                            {pwdVisibility ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </IconButton>
                          <IconButton
                            aria-label="toggle password info"
                            onClick={() => togglePwdStrength()}
                          >
                            <InfoIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    autoComplete="off"
                    size="small"
                    required={isNaN(userId) ? true : false}
                    variant="outlined"
                    label="Old Password: "
                    type={pwdVisibility ? "text" : "password"}
                    name="old_password"
                    value={user && user.old_password}
                    onChange={handleChange}
                  />
                </Grid>
              ) : (
                <></>
              )}
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  InputProps={{
                    inputProps: {
                      autoComplete: "new-password",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle visibility"
                          onClick={() => togglePwdVisibility()}
                        >
                          {pwdVisibility ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                        <IconButton
                          aria-label="toggle password info"
                          onClick={() => togglePwdStrength()}
                        >
                          <InfoIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  autoComplete="off"
                  size="small"
                  required={isNaN(userId) ? true : false}
                  variant="outlined"
                  label="New Password: "
                  type={pwdVisibility ? "text" : "password"}
                  name="new_password"
                  value={user && user.new_password}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  InputProps={{
                    inputProps: {
                      autoComplete: "new-password",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle visibility"
                          onClick={() => togglePwdVisibility()}
                        >
                          {pwdVisibility ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                        <IconButton
                          aria-label="toggle password info"
                          onClick={() => togglePwdStrength()}
                        >
                          <InfoIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  autoComplete="off"
                  size="small"
                  required={isNaN(userId) ? true : false}
                  variant="outlined"
                  label="New Password Confirm: "
                  type={pwdVisibility ? "text" : "password"}
                  name="new_password_confirm"
                  value={user && user.new_password_confirm}
                  onChange={handleChange}
                />
                {user.new_password !== user.new_password_confirm ? (
                  <Typography color="error" variant="caption">
                    Password and Confirm Password field values does not match.
                  </Typography>
                ) : (
                  <></>
                )}
              </Grid>
              {pwdStrength || user.new_password !== "" ? (
                <>
                  <Grid item xs={12} sm={12}>
                    <Divider />
                    <div style={{ paddingLeft: 16, fontSize: "90%" }}>
                      Password must: <br />
                      <FormControlLabel
                        value="start"
                        control={
                          <Checkbox
                            name="pwd_length"
                            value={user.new_password.length >= 8}
                            checked={user.new_password.length >= 8}
                            color={
                              user.new_password.length >= 8
                                ? "success"
                                : "error"
                            }
                            size="small"
                          />
                        }
                        label="Be at least 8 characters long"
                        labelPlacement="end"
                        disableTypography
                        sx={{
                          color:
                            user.new_password.length >= 8
                              ? "#2e7d32"
                              : "#d32f2f",
                        }}
                      />
                      <FormControlLabel
                        value="start"
                        control={
                          <Checkbox
                            name="pwd_numbers"
                            value={!/^\d+$/.test(user.new_password)}
                            checked={!/^\d+$/.test(user.new_password)}
                            color={
                              !/^\d+$/.test(user.new_password)
                                ? "success"
                                : "error"
                            }
                            size="small"
                          />
                        }
                        label="Not only contain numbers"
                        labelPlacement="end"
                        disableTypography
                        sx={{
                          color: !/^\d+$/.test(user.new_password)
                            ? "#2e7d32"
                            : "#d32f2f",
                        }}
                      />
                      <FormControlLabel
                        value="start"
                        control={
                          <Checkbox
                            name="pwd_common"
                            value={!getPwdCommon()}
                            checked={!getPwdCommon()}
                            color={!getPwdCommon() ? "success" : "error"}
                            size="small"
                          />
                        }
                        label={`Not be a common word (eg "password")`}
                        labelPlacement="end"
                        disableTypography
                        sx={{
                          color: !getPwdCommon() ? "#2e7d32" : "#d32f2f",
                        }}
                      />
                      <FormControlLabel
                        value="start"
                        control={
                          <Checkbox
                            name="pwd_similar"
                            value={!getPwdSimilarity()}
                            checked={!getPwdSimilarity()}
                            color={!getPwdSimilarity() ? "success" : "error"}
                            size="small"
                          />
                        }
                        label="Not be too similar to user attributes (eg username, first name, last name, email)"
                        labelPlacement="end"
                        disableTypography
                        sx={{
                          color: !getPwdSimilarity() ? "#2e7d32" : "#d32f2f",
                        }}
                      />
                    </div>
                    <Divider />
                  </Grid>
                </>
              ) : (
                <></>
              )}
              <Grid item xs={12} sm={12}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      value="start"
                      control={
                        <Checkbox
                          name="is_staff"
                          value={user && user.is_staff}
                          checked={user && user.is_staff}
                          onChange={handleChangeAdmin}
                          color="primary"
                        />
                      }
                      label="Is Admin (FriendlyFoods only)"
                      labelPlacement="end"
                    />
                  </FormGroup>
                  <FormHelperText>
                    Enables admin access for the user account. They will be able
                    to view and modify all users, all orders, and place an order
                    on behalf of any account.
                  </FormHelperText>
                </FormControl>
              </Grid>
              {userId ? (
                <Grid item xs={12} sm={12}>
                  <FormControlLabel
                    value="start"
                    control={
                      <Checkbox
                        name="is_active"
                        value={user && user.is_active}
                        checked={user && user.is_active}
                        onChange={handleChange}
                        color="primary"
                      />
                    }
                    label="Is Active"
                    labelPlacement="end"
                  />
                </Grid>
              ) : (
                <></>
              )}
              <Grid item xs={12} sm={12}>
                <FormControlLabel
                  value="start"
                  control={
                    <Checkbox
                      name="email_order_confirmation"
                      value={user && user.email_order_confirmation}
                      checked={user && user.email_order_confirmation}
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label="Email Address Confirmation"
                  labelPlacement="end"
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControlLabel
                  value="start"
                  control={
                    <Checkbox
                      name="account_lock"
                      value={user && user.account_lock}
                      checked={user && user.account_lock}
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label="Account Lock"
                  labelPlacement="end"
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControlLabel
                  value="start"
                  control={
                    <Checkbox
                      name="needs_email_verified"
                      value={user && user.needs_email_verified}
                      checked={user && user.needs_email_verified}
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label="Needs Email Verified"
                  labelPlacement="end"
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControlLabel
                  value="start"
                  control={
                    <Checkbox
                      name="needs_manual_review"
                      value={user && user.needs_manual_review}
                      checked={user && user.needs_manual_review}
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label="Needs Manual Review"
                  labelPlacement="end"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Link
                  to="/users"
                  style={{ textDecoration: "none" }}
                  color="secondary"
                >
                  <Button fullWidth variant="contained" color="primary">
                    <Typography variant="subtitle2" className="text-white">
                      Cancel
                    </Typography>
                  </Button>
                </Link>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={() => toggleConfirmModal()}
                >
                  <Typography variant="subtitle2" className="text-white">
                    Save
                  </Typography>
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </>
  );
};

export default AddUser;
